import { merge, mergeAll, map, finalize } from 'rxjs';

function mergeMultipleDataLayers(layers) {
  const resultStreams = layers.map((l) => l.getResultsStream());
  const resultsMap = /* @__PURE__ */ new Map();
  const deactivationHandlers = [];
  for (const layer of layers) {
    deactivationHandlers.push(layer.activate());
  }
  return merge(resultStreams).pipe(
    mergeAll(),
    map((v) => {
      resultsMap.set(v.origin.state.key, v);
      return resultsMap.values();
    }),
    finalize(() => {
      deactivationHandlers.forEach((handler) => handler());
    })
  );
}

export { mergeMultipleDataLayers };
//# sourceMappingURL=mergeMultipleDataLayers.js.map
